export default "__VITE_ASSET__qIaogVrZ__"